import { useState } from "react";
import { useNavigate } from "react-router";
import { useTenancyAuth } from "@/context/TenancyAuthContext";

export default function TenancyLogin() {
  const [correo, setCorreo] = useState("");
  const [pass, setPass] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { login } = useTenancyAuth();
  const navigate = useNavigate();
  const API = import.meta.env.VITE_API_URL_BACKEND;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await fetch(`${API}/tenants/admin/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ correo_electronico: correo, contrasena: pass }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Credenciales inválidas");
      login(data.token, data.admin);
      navigate("/tenancy");
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex bg-[#fbfaf8] dark:bg-black">
      <div className="flex-1 hidden lg:flex flex-col justify-between p-10">
        <div className="flex items-center gap-2">
          <div className="h-8 w-8 rounded-xl bg-black text-white flex items-center justify-center font-bold">
            T
          </div>
          <span className="font-semibold tracking-tight">Tenancy OS</span>
        </div>
        <div>
          <h1 className="text-[48px] font-[650] leading-[0.9] tracking-[-0.04em] max-w-[520px]">
            Infraestructura para escalar empresas.
            <span className="text-gray-400">
              {" "}
              Una base de datos por cliente.
            </span>
          </h1>
          <p className="mt-6 text-[15px] text-gray-500 max-w-[420px] leading-relaxed">
            Panel master único. Aquí solo entra el superadmin singleton que crea
            y administra todas las empresas.
          </p>
        </div>
        <p className="text-[11px] text-gray-400">
          © 2026 Tenancy Master • Acceso restringido
        </p>
      </div>

      <div className="flex-1 flex items-center justify-center p-6">
        <form
          onSubmit={handleSubmit}
          className="w-full max-w-[380px] rounded-[24px] border border-black/[0.06] bg-white p-8 shadow-[0_20px_80px_-20px_rgba(0,0,0,0.15)] dark:bg-zinc-900 dark:border-white/10"
        >
          <div className="mb-8">
            <h2 className="text-[22px] font-semibold tracking-tight">
              Master Login
            </h2>
            <p className="mt-1 text-[13px] text-gray-500">
              Solo el administrador único del sistema.
            </p>
          </div>

          <div className="space-y-4">
            <div>
              <label className="text-[12px] font-medium text-gray-700 dark:text-gray-300">
                Correo master
              </label>
              <input
                value={correo}
                onChange={(e) => setCorreo(e.target.value)}
                type="email"
                required
                placeholder="master@tenancy.local"
                className="mt-1.5 w-full h-11 rounded-full border border-black/10 bg-[#f9f9f7] px-4 text-[14px] outline-none focus:border-black focus:bg-white dark:bg-white/[0.06] dark:border-white/10 dark:focus:bg-zinc-900"
              />
            </div>
            <div>
              <label className="text-[12px] font-medium text-gray-700 dark:text-gray-300">
                Contraseña
              </label>
              <input
                value={pass}
                onChange={(e) => setPass(e.target.value)}
                type="password"
                required
                placeholder="••••••••"
                className="mt-1.5 w-full h-11 rounded-full border border-black/10 bg-[#f9f9f7] px-4 text-[14px] outline-none focus:border-black focus:bg-white dark:bg-white/[0.06] dark:border-white/10"
              />
            </div>
            {error && (
              <p className="text-[12px] text-red-500 bg-red-50 border border-red-100 rounded-full px-3 py-2 dark:bg-red-950/30 dark:border-red-900/30">
                {error}
              </p>
            )}
            <button
              disabled={loading}
              className="mt-2 w-full h-11 rounded-full bg-black text-white text-[14px] font-medium hover:bg-zinc-800 disabled:opacity-50 dark:bg-white dark:text-black"
            >
              {loading ? "Entrando..." : "Entrar al panel master"}
            </button>
          </div>

          <p className="mt-6 text-center text-[11px] text-gray-400">
            Este panel no crea usuarios master. El único admin se crea por el
            sistema al iniciar el backend.
          </p>
        </form>
      </div>
    </div>
  );
}
